var map = {
	"./1.jpg": 9140,
	"./10.jpg": 7942,
	"./11.jpg": 6467,
	"./12.jpg": 8340,
	"./13.jpg": 5713,
	"./14.jpg": 6482,
	"./15.jpg": 9151,
	"./2.jpg": 5363,
	"./3.jpg": 6950,
	"./4.jpg": 3293,
	"./5.jpg": 5200,
	"./7.jpg": 9138,
	"./8.jpg": 1849,
	"./9.jpg": 4060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9038;